module.exports = __webpack_public_path__ + "img/marker-no-shadow.1e6bc802.svg";